import React, { useState, useMemo } from "react";
import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { ZustandStore } from "../../../store/zustand-store";
import globeImg from "../../Assets/rank-tracking-assets/www.svg";
import { getCountryFlag } from "../../../helperJs/getCountryFlag";
import { useTranslation } from "react-i18next";

const BusinessLocation = () => {
  const {
    map_keyword_loc_data,
    map_keyword_latest_data,
    map_keyword_old_data,
    USERCURRENTPROJECTLOCATION,
    CURRLOCATION,
  } = ZustandStore((state) => state);
  const { t } = useTranslation();

  const [filter, setFilter] = useState("");

  const getCurrentCountryDetails = () => {
    if (CURRLOCATION.name === "All Locations") {
      return globeImg;
    }
    return getCountryFlag(CURRLOCATION.name);
  };

  const locationArr = useMemo(() => {
    const dataWithFlags = USERCURRENTPROJECTLOCATION?.map((item) => {
      return {
        ...item,
        location_flag: getCountryFlag(item.location_name),
      };
    });
    const dataFilter = dataWithFlags.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.location_name === item.location_name)
    );

    return [
      {
        location_name: "All Locations",
        location_code: "All Locations",
        location_flag: globeImg,
      },
      ...dataFilter,
    ];
  }, [USERCURRENTPROJECTLOCATION]);

  const options = useMemo(
    () =>
      locationArr?.filter((value) => {
        return value?.location_name
          .toString()
          .toLowerCase()
          .includes(filter.toLowerCase());
      }),
    [filter, locationArr]
  );

  const LocationHandler = (e) => {
    const selectedObj = options.find((option) => option.location_name === e);
    if (!selectedObj) return;
    if (
      selectedObj?.location_name === map_keyword_loc_data &&
      map_keyword_old_data?.length > 0 &&
      map_keyword_latest_data?.length > 0
    )
      return;
    ZustandStore.setState({
      CURRLOCATION: {
        name: selectedObj?.location_name,
        code: selectedObj?.location_code,
      },
      mapshowloader: true,
      map_top_rank: {
        data: [],
        top_rank: false,
        type: "",
        competitors: false,
      },
      selected_project_id: null,
      RANKMOVEDUP: 0,
      RANKMOVEDDOWN: 0,
      USERALLPENDINGRESULT: [],
      USERALLKEYWORDRESULT: [],
      RANKKEYWORD: [],
      SELECTEDPROJECTNEWDATA: [],
      USERCOMPATITORS: [],
      PREVIOUSALLOLDDATA: [],
      OLDKEYWORDDATA: [],
      USERCURRENTPROJECTLOCATION: [],
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
  };

  return (
    <Flex direction="column">
      <Select
        placeholder={CURRLOCATION.name}
        value={CURRLOCATION.name}
        onChange={LocationHandler}
        w="100%"
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: "35px",
          }}
        >
          <Select.Trigger.Addon>
            <img
              src={getCurrentCountryDetails()}
              alt="flag"
              style={{ width: "20px", objectFit: "contain" }}
              className="me-1"
            />
          </Select.Trigger.Addon>
          <Select.Trigger.Text>{CURRLOCATION.name || ""}</Select.Trigger.Text>
        </Select.Trigger>
        <Select.Popper aria-label={"Project options with search"}>
          <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            {options.map((value) => (
              <Select.Option
                value={value.location_name}
                key={value.location_name}
                style={{
                  boxShadow: "none",
                }}
              >
                <img
                  src={value.location_flag}
                  alt="flag"
                  style={{ width: "20px", objectFit: "contain" }}
                  className="me-1"
                />
                {value.location_name}
              </Select.Option>
            ))}
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length}{" "}
                {t("rank_tracking.map_rank_tracker.add_first_project.result")}
                {options.length > 1 && "s"}{" "}
                {t("rank_tracking.map_rank_tracker.add_first_project.found")}
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                Nothing{" "}
                {t("rank_tracking.map_rank_tracker.add_first_project.found")}
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default BusinessLocation;
